export const DRIVE_URLS = {
  CV: "https://drive.google.com/file/d/127TKMufVjB17SJRYeNDU5NcmGuMtIl9f/view?usp=sharing",
};

export const SKILLS_URLS = {
  HTML5: "https://developer.mozilla.org/en-US/docs/Glossary/HTML5",
  CSS3: "https://developer.mozilla.org/en-US/docs/Web/CSS",
  JavaScript: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
  React: "https://react.dev/",
  TypeScript: "https://www.typescriptlang.org/",
  Redux: "https://redux.js.org/",
  TailwindCSS: "https://tailwindcss.com/",
  Git: "https://git-scm.com/",
  Next: "https://nextjs.org/",
  GraphQL: "https://graphql.org/",
};
